import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-grid-input-control',
    templateUrl: './grid-input-control.component.html',
    styleUrls: ['./grid-input-control.component.scss'],
    standalone: false
})
export class GridInputControlComponent implements OnInit {
    @Input()
    parentFormGroup: UntypedFormGroup;

    @Input()
    dynamicFormControlName: string;

    @Output() valueChange = new EventEmitter<string>();
    @Output() statusChange = new EventEmitter<boolean>();
    @Output() blurr = new EventEmitter<boolean>();

    inputFocus = false;

    constructor() {
    }

    ngOnInit() {
        this.parentFormGroup.get(this.dynamicFormControlName).valueChanges.subscribe(
            (value) => {
                if (this.parentFormGroup.get(this.dynamicFormControlName).valid) {
                    this.valueChange.emit(value);
                }
            });
        this.parentFormGroup.get(this.dynamicFormControlName).statusChanges.subscribe(
            value => this.statusChange.emit(this.parentFormGroup.get(this.dynamicFormControlName).valid)
        );
    }

    isInvalidAndDirty(groupControl, columnName) {
        if (!groupControl || !columnName || !groupControl.controls[columnName]) {
            return true;
        }
        return !groupControl.controls[columnName].valid && groupControl.controls[columnName].dirty;
    }

    isInvalidAndTouched(groupControl, columnName) {
        if (!groupControl || !columnName || !groupControl.controls[columnName]) {
            return true;
        }
        return !groupControl.controls[columnName].valid && groupControl.controls[columnName].touched;
    }

    onInputFocus() {
        this.inputFocus = true;
    }

    onInputBlurr() {
        this.inputFocus = false;
        const isWrong = this.parentFormGroup.get(this.dynamicFormControlName).dirty && !this.parentFormGroup.get(this.dynamicFormControlName).valid;
        this.blurr.emit(isWrong)
    }
}
